/* eslint-disable */
import placeholder from '../../assets/placeholder.svg'
import { Checkbox } from '../../Components/ui/checkbox'
import env from '../../env/env'
import { toCurrency } from '../../utils/CurrencyUtil'
import { capitalizeWords } from '../../utils/Util'

const ActionPlanPlanCards = ({
  adminPlans,
  selectedPlans,
  openPlans,
  handleCheckboxChange,
  togglePlan,
  onOpen,
  isDesktop,
}) => {
  return (
    <div className='md:flex gap-2 pb-40'>
      <div className='flex-[2] md:grid md:grid-cols-2 lg:grid-cols-2 flex flex-col gap-4 md:gap-4 mb-[170px] overflow-y-scroll hide-scrollbar'>
        {adminPlans?.map((plan, index) => {
          return (
            <div
              key={plan.customerBasketInvestmentId + index}
              className={`border border-[#D3DBEC] py-4 px-3 md:p-5 rounded-[6px] overflow-hidden transition-all duration-300 ease-in-out`}
            >
              <div className='flex justify-between'>
                <div className='flex gap-3 items-start'>
                  <Checkbox
                    className='h-5 w-5'
                    checked={selectedPlans?.some((p) => p.basketIndex === plan?.basketIndex)}
                    onCheckedChange={() => handleCheckboxChange(plan)}
                  />
                  <img src={placeholder} className='h-6 w-6 md:h-8 md:w-8' alt='plan' />
                  <div className='font-DMSans md:text-lg text-base font-medium'>
                    {plan.customerBasketName}
                  </div>
                </div>
              </div>

              <div className='flex justify-between mt-3'>
                <div className='flex-1'>
                  <h1 className='font-DMSans font-medium text-xs md:text-base text-black-300 flex gap-2 items-center'>
                    One time
                  </h1>
                  <p className='font-DMSans mt-2 font-semibold text-sm md:text-lg text-[#2d2d2d]'>
                    ₹
                    {plan.oneTimeInvestmentAmount && plan?.oneTimeStatus === 'PENDING'
                      ? toCurrency(plan.oneTimeInvestmentAmount)
                      : 0}
                  </p>
                  {plan.oneTimeInvestmentAmount > 0 && plan?.oneTimeStatus === 'PENDING' && (
                    <p
                      className='mt-3 text-primary-700 font-DMSans font-medium text-xs cursor-pointer'
                      onClick={() => {
                        onOpen('oneTimeBreakdown', {
                          constituents: plan?.oneTimeInvestmentBreakdown?.filter(
                            (fund) => fund?.weightage != 0,
                          ),
                        })
                      }}
                    >
                      View Funds
                    </p>
                  )}
                </div>

                {console.log("plan", plan)}

                {(plan?.sipStatus === 'PENDING' || plan?.sipStatus === 'ACTIVE') && (
                  <div className='flex-1'>
                    <h1 className='font-DMSans font-medium text-xs md:text-base text-black-300 flex gap-2 items-center'>
                      SIP{' '}
                      <span
                        className={`text-xs ${capitalizeWords(plan?.sipStatus) === 'Active'
                          ? 'text-secondary-500 bg-secondary-50 rounded-full px-2 border border-secondary-500'
                          : 'text-warning-500 bg-warning-50 rounded-full px-2  border border-warning-500'
                          }`}
                      >
                        {capitalizeWords(plan?.sipStatus) === 'Active' ? 'Active' : 'Pending'}
                      </span>
                    </h1>

                    <p className='font-DMSans mt-2 font-semibold text-sm md:text-lg text-[#2d2d2d]'>
                      ₹{plan.sipInvestmentAmount ? toCurrency(plan.sipInvestmentAmount) : 0}
                    </p>

                    {plan.sipInvestmentAmount > 0 && (
                      <p
                        className='mt-3 text-primary-700 font-DMSans font-medium text-xs cursor-pointer'
                        onClick={() => {
                          onOpen('sipBreakdown', {
                            constituents: plan?.sipInvestmentBreakdown?.filter(
                              (fund) => fund?.weightage != 0,
                            ),
                            totalAmount: plan?.sipInvestmentAmount,
                          })
                        }}
                      >
                        View Funds
                      </p>
                    )}
                  </div>
                )}
              </div>

              <div onClick={() => togglePlan(plan.customerBasketInvestmentId)}>
                {openPlans[plan.customerBasketInvestmentId] && (
                  <>
                    {((plan.sipInvestmentAmount > 0 && !plan.oneTimeInvestmentAmount) ||
                      (plan.oneTimeInvestmentAmount > 0 && plan.sipInvestmentAmount > 0)) && (
                        <div className='my-3 md:mt-5 border-t border-[#D3DBEC]'>
                          {plan?.sipInvestmentBreakdown?.length > 0 &&
                            plan?.sipInvestmentBreakdown?.map((breakup, breakupIndex) => {
                              const percentage =
                                (breakup.investmentAmount / plan.sipInvestmentAmount) * 100
                              return (
                                <div
                                  key={breakupIndex}
                                  className='flex mt-3 justify-between items-center gap-10'
                                >
                                  <div className='flex gap-2 items-center'>
                                    <img
                                      src={`${env.MF_LOGOS_URL}/${breakup.amcCode}.png`}
                                      alt={`${breakup.name} icon`}
                                      className='rounded-[8px] h-6 w-6 md:h-8 md:w-8'
                                    />
                                    <p className='font-DMSans text-sm font-medium text-black-500'>
                                      {isDesktop
                                        ? breakup?.schemeName
                                        : `${breakup?.schemeName.slice(0, 20)}...`}
                                    </p>
                                  </div>
                                  <p className='font-DMSans text-sm font-medium text-black-500'>
                                    {percentage}%
                                  </p>
                                </div>
                              )
                            })}
                        </div>
                      )}

                    {plan.oneTimeInvestmentAmount > 0 && plan.sipInvestmentAmount === 0 && (
                      <div className='my-3 md:mt-5 border-t border-[#D3DBEC]'>
                        {plan?.oneTimeInvestmentBreakdown.length > 0 &&
                          plan?.oneTimeInvestmentBreakdown?.map((breakup, breakupIndex) => {
                            const percentage =
                              (breakup.investmentAmount / plan.oneTimeInvestmentAmount) * 100
                            return (
                              <div
                                key={breakupIndex}
                                className='flex mt-3 justify-between items-center gap-10'
                              >
                                <div className='flex gap-2 items-center'>
                                  <img
                                    src={`${env.MF_LOGOS_URL}/${breakup.amcCode}.png`}
                                    alt={`${breakup.name} icon`}
                                    className='rounded-[8px] h-6 w-6 md:h-8 md:w-8'
                                  />
                                  <p className='font-DMSans text-sm font-medium text-black-500'>
                                    {isDesktop
                                      ? breakup?.schemeName
                                      : `${breakup?.schemeName.slice(0, 20)}...`}
                                  </p>
                                </div>
                                <p className='font-DMSans text-sm font-medium text-black-500'>
                                  {percentage}%
                                </p>
                              </div>
                            )
                          })}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ActionPlanPlanCards
